<template>
  <section class="body">
    <!-- <div> -->
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <div class="modal-top-section modal-top-section--align-center">
        <h3 class="modal-top-section__title">Datos básicos de la cola</h3>
        <p class="modal-top-section__subtitle">Completa los campos requeridos</p>
      </div>

      <div class="padding-10">
        <a-form-item label="Nombre de la cola" name="name">
          <a-input v-model:value="formState.name" placeholder="Escribir aquí" />
        </a-form-item>
        <a-form-item label="Campaña" name="portfolio">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.portfolio"
            :disabled="isEdit"
            placeholder="Seleccionar una campaña"
            @change="handlePortfolioChange"
            :loading="loadingPortfolios"
          >
            <a-select-option v-for="portfolio in portfolios" :key="portfolio.id">
              {{ portfolio.name }}
            </a-select-option>

            <template #dropdownRender v-if="portfolios.length === 0">
              <div class="dropdown-default__wrapper">
                Crea tu primera campaña 💪 . Haz
                <router-link to="/operations/campaigns">click aquí</router-link>
              </div>
            </template>
          </a-select>
          <div class="text-entity">
            <p v-if="entitySelected">Empresa: {{ entitySelected.name }}</p>
            <p v-else>Empresa a la que pertenece la campaña</p>
          </div>
        </a-form-item>
        <a-form-item label="Orden de obtención de tickets" name="distributionType">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.distributionType"
            placeholder="Seleccionar tipo de orden"
          >
            <a-select-option v-for="distribution in distributions" :key="distribution.value">
              <a-popover
                :title="distribution.label"
                trigger="hover"
                placement="right"
                :overlayStyle="{ width: '250px' }"
              >
                <template #content>
                  <div class="container__text">
                    {{ distribution.tooltip }}
                  </div>
                </template>
                <div style="width: 100%">{{ distribution.label }}</div></a-popover
              >
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <a-row class="padding-10">
        <a-col :span="10">
          <a-form-item name="levelService">
            <template #label>
              Nivel de servicio &nbsp;
              <a-tooltip>
                <template #title>
                  Tiempo máximo esperado para que un usuario atienda un ticket. Si se pasa este
                  tiempo, se mostrará en el reporte de nivel de servicio.
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </template>
            <div>
              <span>Segundos:</span>
              <a-input-number
                v-model:value="formState.levelService"
                placeholder="01"
                style="margin-left: 8px"
              />
            </div>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="10">
            <a-form-item name="waitingThreshold">
              <template #label>
                Umbral de espera &nbsp;
                <a-tooltip>
                  <template #title>
                    Tiempo máximo que se desea tener a un contacto en espera, antes de ser atendido
                    por un usuario. Si se pasa este tiempo, se mostrará en el reporte de nivel de
                    servicio.
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </template>
              <div>
                Segundos
                <a-input-number v-model:value="formState.waitingThreshold" placeholder="01" />
              </div>
            </a-form-item>
          </a-col> -->
      </a-row>
      <div class="padding-10">
        <a-form-item name="maxTicketsAgents">
          <template #label>
            Cantidad máxima de tickets de mensajería por usuario &nbsp;
            <a-tooltip>
              <template #title>
                Cantidad de tickets en simultáneo que tendrá un usuario para atender. Válido
                únicamente para tickets entrantes y salientes de mensajería.
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </template>

          <a-input-number
            class="max-tickets-input"
            v-model:value="formState.maxTicketsAgents"
            placeholder="01"
          />
        </a-form-item>
        <a-form-item name="distributionTime">
          <template #label>
            Tiempo de repartición &nbsp;
            <a-tooltip>
              <template #title>
                El sistema contemplará este tiempo para poder realizar la repartición de tickets.
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </template>
          <a-row>
            <a-col :span="14" class="gutter-row">
              <a-select
                v-model:value="formState.repartitionType"
                placeholder="Seleccionar tipo de orden"
              >
                <a-select-option v-for="type in typeRepartition" :key="type.value">
                  {{ type.label }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="9" :offset="1" class="gutter-row">
              <time-picker-type
                v-model:value="formState.distributionTime"
                :disabled="!formState.repartitionType"
                :format="formState.repartitionType"
                :show-now="false"
                :placeholder="
                  formState.repartitionType == 'mm'
                    ? 'Seleccionar minutos'
                    : formState.repartitionType == 'ss'
                    ? 'Seleccionar segundos'
                    : ''
                "
              />
              <!-- <a-input-number
                  class="max-tickets-input"
                  v-model:value="formState.maxTicketsAgents"
                  placeholder="01"
                /> -->
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item name="automaticReplyType">
          <template #label>
            <span style="font-weight: 500">
              Envío de respuestas rápidas automatizadas &nbsp;
            </span>
            <a-tooltip>
              <template #title>
                Las respuestas rápidas automatizadas se crean en el módulo Ajustes de la plataforma. Recuerda asignarlas a esta cola para utilizarlas.
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </template>
          <p class="info">
            Define si la respuesta rápida automatizada se enviará automáticamente al tipificar o 
            si quedará a criterio del usuario.
          </p>

          <a-radio-group
            v-model:value="formState.automaticReplyType"
            @change="onAutomaticReplyTypeChange"
          >
            <a-radio :value="SentReply.None" :style="radioStyle">
              Ninguno
              <a-tooltip>
                <template #title>
                  No se podrá utilizar el envío de respuestas rápidas automatizadas.
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </a-radio>

            <a-radio :value="SentReply.Automatic" :style="radioStyle">
              Obligatorio automático
              <a-tooltip>
                <template #title>
                  El usuario deberá seleccionar obligatoriamente una respuesta rápida automatizada durante la tipificación.
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </a-radio>

            <a-radio :value="SentReply.ByUser" :style="radioStyle">
              A criterio del usuario
              <a-tooltip>
                <template #title>
                  El usuario podrá elegir si desea enviar o no una respuesta rápida automatizada durante la tipificación.
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </a-radio>

          </a-radio-group>
        </a-form-item>

        <automatic-reply-picker
          v-model:value="formState.automaticReply"
          label="Elige tu respuesta rápida automatizada"
          multiple
          :queue="idQueue"
          :disabled="formState.automaticReplyType === SentReply.None"
          :showTooltip="false"
          :rules="[
            {
              required: formState.automaticReplyType !== SentReply.None,
              message: 'Campo requerido',
            },
          ]"
        />

        <div class="d-flex">
          <span class="subtitle-bold">Repartición de tickets</span>
          <div>
            <span class="subtitle-bold">
              {{ formState.enableCustomTicketDistribution ? "Desactivar" : "Activar" }}
              configuración
            </span>
            <a-switch v-model:checked="formState.enableCustomTicketDistribution" size="small" />
          </div>
        </div>
        <div class="block block--light info">
          <InfoCircleOutlined class="icon" />
          <span class="info--text" action="Cerrar">
            Si esta opción no esta activa, todos los tickets serán repartidos.
          </span>
        </div>
        <a-form-item name="ticketsToDistribute">
          <template #label>
            Cantidad de tickets a repartir &nbsp;
            <a-tooltip>
              <template #title>
                Cantidad de repartición máxima que respetará el sistema. Válido únicamente 
                para tickets entrantes.
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </template>
          <a-select
            :disabled="!formState.enableCustomTicketDistribution"
            v-model:value="formState.ticketsToDistribute"
          >
            <a-select-option v-for="count in ticketToDistributeList" :key="count">
              {{ count }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </a-form>
    <!-- </div> -->
  </section>
</template>

<script>
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import TimePickerType from "@/app/shared/components/pickers/TimePickerType.vue";
import AutomaticReplyPicker from "@/app/shared/components/pickers/AutomaticReplyPicker.vue"; 
import { SentReply } from "@/@types/queue/sent";

const distributions = [
  {
    label: "Primero en entrar, primero en salir (FIFO)",
    tooltip:
      "Cada uno de los tickets será atendido según su orden de llegada. En este sentido, los tickets que ingresaron primero (los más antiguos) serán los primeros en ser atendidos.",
    value: 1,
  },
  {
    label: "Último en entrar, primero en salir (LIFO)",
    tooltip:
      "Los tickets que ingresan al final serán los primeros en ser atendidos y los tickets que ingresaron primero a la plataforma (los más antiguos) serán los últimos atenderse.",
    value: 2,
  },
];

const ticketToDistributeList = [1, 5, 10, 20, 30, 40, 50, 60];

export default defineComponent({
  components: {
    InfoCircleOutlined,
    TimePickerType,
    AutomaticReplyPicker,
  },
  props: {
    isActive: {
      required: true,
      type: Boolean,
    },
    isEdit: {
      required: true,
      type: Boolean,
      default: false,
    },
    queuePortfolios: {
      type: Array,
      default: null,
    },
    idQueue: {
      required: false,
      type: Number,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const formRef = ref();
    const entitySelected = ref(null);
    const record = computed(() => store.getters["getQueueState"]);

    let portfolios = null;

    if (props.queuePortfolios) {
      portfolios = computed(() => props.queuePortfolios);
    } else {
      portfolios = computed(() => store.getters["getFilteredPortfolios"]);
    }

    const typeTime = (time) => {
      if (time) {
        const [hours, minutes, seconds] = time.split(":").map(Number);

        if (minutes > 0) {
          return { repartitionType: "mm", distributionTime: minutes };
        } else if (seconds > minutes) {
          return { repartitionType: "ss", distributionTime: seconds };
        }
      }
      return { repartitionType: "ss", distributionTime: 15 };
    };

    const formState = reactive({
      name: record.value.name,
      portfolio: record.value.portfolios.length > 0 ? record.value.portfolios[0] : null,
      distributionType: record.value.distribution_type,
      maxTicketsAgents: record.value.max_tickets_agents,
      levelService: record.value.level_service,
      waitingThreshold: record.value.waiting_threshold,
      ...typeTime(record.value.distribution_time),
      enableCustomTicketDistribution: record.value.enable_custom_ticket_distribution,
      ticketsToDistribute: record.value.tickets_to_distribute ?? 10,
      // ...typeTime(record.value.distribution_time),
      automaticReplyType: record.value?.automatic_reply_type?.id ?? SentReply.None,
      automaticReply: Array.isArray(record?.value?.automatic_reply)
        ? record.value.automatic_reply.map(item => item.id).filter(id => id != null)
        : []
    });

    const selectedPortfolio = computed(() => {
      return portfolios.value?.find(p => p.id == formState.portfolio) ?? null;
    });

    const hasTipifications = computed(() => Number(selectedPortfolio.value?.num_tipificactions ?? 0) > 0);

    const resetAutomaticReplyToNone = (showError = true) => {
      formState.automaticReplyType = SentReply.None;
      formState.automaticReply = [];
      if (showError) {
        message.error(
          "La campaña asociada a esta cola debe tener tipificaciones activas."
        );
      }
    };

    const onAutomaticReplyTypeChange = (e) => {
      const next = e?.target?.value ?? e;
      const intentaBloqueado =
        (next === SentReply.Automatic || next === SentReply.ByUser) && !hasTipifications.value && props.isEdit;

      if (intentaBloqueado) {
        resetAutomaticReplyToNone(true);
      }
    };

    const radioStyle = reactive({
      display: 'flex',
      height: '30px',
      lineHeight: '30px',
    });

    const queues = computed(() => store.getters["getQueueInfo"]);

    const checkName = async (rule, value) => {
      if (value == "") {
        return Promise.reject("Campo nombre es requerido");
      } else if (
        queues.value.items.some((item) => item.name.toLowerCase() === value.toLowerCase()) &&
        value.toLowerCase() !== record.value.name.toLowerCase()
      ) {
        return Promise.reject("Este nombre ya esta en usó");
      } else {
        return Promise.resolve();
      }
    };
    const checkNumber = async (rule, value) => {
      if (value === "") {
        return Promise.reject("Campo requerido");
      } else if (value <= 0) {
        return Promise.reject("Ingresa un valor mayor a 0");
      } else {
        return Promise.resolve();
      }
    };
    const rules = {
      name: [{ required: true, validator: checkName, trigger: "change" }],
      portfolio: [{ required: true, message: "Campo requerido" }],
      distributionType: [{ required: true, message: "Campo requerido" }],
      maxTicketsAgents: [
        {
          pattern: /^[0-9]*$/,
          message: "Solo números enteros",
        },
        { required: true, validator: checkNumber, trigger: "change" },
      ],
      levelService: [
        {
          pattern: /^[0-9]*$/,
          message: "Solo números enteros",
        },
        { required: true, validator: checkNumber, trigger: "change" },
      ],
      waitingThreshold: [
        {
          pattern: /^[0-9]*$/,
          message: "Solo números enteros",
        },
        { required: true, validator: checkNumber, trigger: "change" },
      ],
      distributionTime: [{ required: true, message: "Campo requerido" }],
      ticketsToDistribute: [{ required: true, message: "Campo requerido" }],
    };

    watch(formState, () => {
      emit("onShowConfirmationModal");
    });

    const handlePortfolioChange = (event) => {
      const entity = portfolios.value.find((portfolio) => portfolio.id == event);
      entitySelected.value = entity?.entity;
    };

    const typeRepartition = [
      { value: "ss", label: "Segundos" },
      { value: "mm", label: "Minutos" },
    ];

    return {
      formRef,
      formState,
      radioStyle,
      rules,
      record,
      portfolios,
      entitySelected,
      handlePortfolioChange,
      queues,
      typeRepartition,
      selectedPortfolio,
      hasTipifications,
      onAutomaticReplyTypeChange,
      SentReply,
    };
  },
  data() {
    return {
      distributions,
      ticketToDistributeList,
      loadingPortfolios: false,
    };
  },
  async mounted() {
    this.loadingPortfolios = true;
    await this.$store.dispatch("fetchAllPortfoliosByEntity");
    if (this.isEdit) {
      this.handlePortfolioChange(this.formState.portfolio);
    }
    this.loadingPortfolios = false;
  },
  computed: {
    disabled() {
      return (
        this.formState.name == "" ||
        this.formState.portfolio == "" ||
        !this.formState.distributionType ||
        !this.formState.maxTicketsAgents ||
        !this.formState.levelService
      );
    },
    active() {
      return this.isActive;
    },
  },
  watch: {
    disabled: {
      handler(value) {
        this.$emit("disable", value);
      },
      immediate: true,
    },
  },
  methods: {
    convertToTimeFormat(unit, amount) {
      let seconds = 0,
        minutes = 0,
        hours = 0;

      switch (unit) {
        case "ss":
          seconds = amount;
          break;
        case "mm":
          minutes = amount;
          break;
        case "hh":
          hours = amount;
          break;
        default:
          throw new Error("Unidad no válida");
      }

      // Formatear a HH:mm:ss
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(
        seconds
      ).padStart(2, "0")}`;
    },
    async handleOk(current) {
      console.log("record04", this.record.automatic_reply_type);
      console.log("formState04", this.formState.automaticReplyType);
      let value = current;
      await this.formRef.validate().then(() => {
        const data = {
          name: this.formState.name,
          portfolios: [this.formState.portfolio],
          level_service:
            this.record.level_service != this.formState.levelService
              ? this.formState.levelService
              : null,
          waiting_threshold:
            this.record.waiting_threshold != this.formState.waitingThreshold
              ? this.formState.waitingThreshold
              : null,
          distribution_type:
            this.record.distribution_type != this.formState.distributionType
              ? this.formState.distributionType
              : null,
          max_tickets_agents:
            this.record.max_tickets_agents != this.formState.maxTicketsAgents
              ? this.formState.maxTicketsAgents
              : null,
          distribution_time:
            this.record.distribution_time != this.formState.distributionTime
              ? this.convertToTimeFormat(
                  this.formState.repartitionType,
                  this.formState.distributionTime
                )
              : null,
          enable_custom_ticket_distribution:
            this.record.enable_custom_ticket_distribution !=
            this.formState.enableCustomTicketDistribution
              ? this.formState.enableCustomTicketDistribution
              : false,
          tickets_to_distribute:
            this.record.tickets_to_distribute != this.formState.ticketsToDistribute
              ? this.formState.ticketsToDistribute
              : null,
          automatic_reply_type:
            this.record.automatic_reply_type != this.formState.automaticReplyType
              ? this.formState.automaticReplyType
              : null,
          automatic_reply:
            this.record.automatic_reply != this.formState.automaticReply
              ? this.formState.automaticReply
              : null,
        };
        this.$store.dispatch("setQueueProperties", data);
        value = current + 1;
        console.log("data04", data);
      });
      return value;
    },
    handleReset() {
      this.formRef.resetFields();
    },
  },
});
</script>

<style lang="sass" scoped>
.body
  // padding: 0 50px
.max-tickets-input
  width: 100%

.picker
  &__label
    display: block
    margin-bottom: 8px
.container__text
  font-size: 12px
  margin-bottom: 3px
  width: 200px
.text-entity
  color: $gray-6
  font-size: 14px
  margin-top: 2px
  margin-bottom: -10px
.padding-10
  padding: 0 50px
  justify-content: space-between

.dropdown-default__wrapper
  margin: 36px auto
  width: 190px
  text-align: center
  color: $gray-8

:deep(.ant-form-item-label)
  width: 100%
.d-flex
  width: 100%
  display: flex
  justify-content: space-between
// .d-flex
//   width: 100%
//   display: flex
.subtitle-bold
  font-weight: 500
  margin-right: 10px

.block
  padding: 16px 12px 20px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px
  background-color: $gray-3

  &--light
    border: 1px solid #dcdcdc
    color: $gray-8
    padding: 8px 12px
    margin: 8px 0 12px 0

  &__disabled
    background-color: $gray-3

  .anticon
    align-items: start
    margin-top: 4px

.info
  color: $gray-8
  font-size: 12px
  display: flex
  margin-top: 4px
  margin-bottom: 12px

.icon
  margin: 3px 6px 0 0
</style>
